import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

/**
 * 세그먼트 버튼 그룹 (선택 = 다크 필, 미선택 = 화이트 + 보더)
 *
 * 사용처: 포인트 적립/차감 모달의 [적립|차감] 토글, 판매등록 모달의 결제수단 [카드|현금|계좌이체]
 *
 * <CommonSegmentedControl
 *   options={[
 *     { value: 'EARN', label: '적립' },
 *     { value: 'DEDUCT', label: '차감' },
 *   ]}
 *   value={type}
 *   onChange={setType}
 * />
 */

const SegmentContainer = styled(Box)({
  display: 'flex',
  gap: 8,
  width: '100%',
});

const SegmentButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isSelected',
})(({ isSelected }) => ({
  flex: 1,
  height: 40,
  borderRadius: 4,
  fontSize: 14,
  fontWeight: 600,
  boxShadow: 'none',
  border: isSelected ? '1px solid #262626' : '1px solid #D9D9D9',
  backgroundColor: isSelected ? '#262626' : '#FFFFFF',
  color: isSelected ? '#FFFFFF' : '#3D3D3D',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: isSelected ? '#262626' : '#F5F5F5',
    border: isSelected ? '1px solid #262626' : '1px solid #D9D9D9',
  },
}));

const CommonSegmentedControl = ({ options = [], value, onChange, disabled = false, ...rest }) => {
  return (
    <SegmentContainer {...rest}>
      {options.map(option => (
        <SegmentButton
          key={option.value}
          disableRipple
          disabled={disabled}
          isSelected={option.value === value}
          onClick={() => onChange(option.value)}>
          {option.label}
        </SegmentButton>
      ))}
    </SegmentContainer>
  );
};

export default CommonSegmentedControl;
